import { Download, RotateCcw, Sparkles, WalletCards, X } from 'lucide-react';
import type { WalletTransaction } from '../types';

interface DemoToolsProps {
  balance: number;
  transactions: WalletTransaction[];
  onClose: () => void;
  onAddDiamonds: () => void;
  onExportAnalytics: () => void;
  onReset: () => void;
}

export function DemoTools({ balance, transactions, onClose, onAddDiamonds, onExportAnalytics, onReset }: DemoToolsProps) {
  return (
    <div className="drawer-backdrop" onMouseDown={onClose}>
      <aside className="tools-drawer" role="dialog" aria-modal="true" aria-label="Demo controls" onMouseDown={(event) => event.stopPropagation()}>
        <button className="drawer-close" onClick={onClose} aria-label="Close demo controls"><X /></button>
        <span className="eyebrow">Testing utilities</span>
        <h2>Demo controls</h2>
        <p>Use these controls during moderated testing. All state is stored only in this browser.</p>
        <div className="tool-stat"><WalletCards /><span>Diamond balance</span><strong>{balance}</strong></div>
        <div className="tool-buttons">
          <button className="button button-secondary" onClick={onAddDiamonds}><Sparkles /> Add 20 diamonds</button>
          <button className="button button-secondary" onClick={onExportAnalytics}><Download /> Export session analytics</button>
          <button className="button button-danger" onClick={onReset}><RotateCcw /> Reset complete demo</button>
        </div>
        <h3>Recent wallet activity</h3>
        <div className="transaction-list">
          {transactions.slice().reverse().slice(0, 8).map((transaction) => (
            <div key={transaction.id} className="transaction-row">
              <span>{transaction.description}<small>{new Date(transaction.createdAt).toLocaleString()}</small></span>
              <strong className={transaction.amount >= 0 ? 'positive' : 'negative'}>{transaction.amount > 0 ? '+' : ''}{transaction.amount}</strong>
            </div>
          ))}
        </div>
      </aside>
    </div>
  );
}
